"use client";

import { Close as ClosePrimitive, type DialogCloseProps } from "@radix-ui/react-dialog";
import { Slot } from "@radix-ui/react-slot";

import { useDialogNestedContext } from "./stack/context";

export type { DialogCloseProps } from "@radix-ui/react-dialog";

const Close = ({ asChild, onClick, ...props }: DialogCloseProps) => {
  const nested = useDialogNestedContext();

  if (!nested) {
    return <ClosePrimitive asChild={asChild} onClick={onClick} {...props} />;
  }

  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      type={asChild ? undefined : "button"}
      onClick={event => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          nested.setOpen(false);
        }
      }}
      {...props}
    />
  );
};

Close.displayName = ClosePrimitive.displayName;

export default Close;
